/**
 * Port of {@class RuleParseException} —
 * backend/src/main/java/com/irian/iam/ruleengine/api/RuleParseException.java
 *
 * Exception thrown when parsing a rule condition expression fails.
 */

export class RuleParseException extends Error {
    readonly position: number
    readonly expression: string
    readonly cause: Error | null

    constructor(message: string, expression: string, position: number, cause: Error | null = null) {
        super(formatMessage(message, expression, position))
        this.name = 'RuleParseException'
        this.expression = expression
        this.position = position
        this.cause = cause
    }
}

function formatMessage(message: string, expression: string, position: number): string {
    if (expression === null || position < 0) return message
    const sb: string[] = [message, ` at position ${position}\n`, expression, '\n', ' '.repeat(Math.max(0, position)), '^']
    return sb.join('')
}
